import { render, staticRenderFns } from "./table-comparison.vue?vue&type=template&id=67e316bd&scoped=true&"
import script from "./table-comparison.vue?vue&type=script&lang=js&"
export * from "./table-comparison.vue?vue&type=script&lang=js&"
import style0 from "./table-comparison.vue?vue&type=style&index=0&id=67e316bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e316bd",
  null
  
)

export default component.exports